//
//
//
//
//
//

import {base} from '../../common/mixins'

export default {
  name: 'CircleRipple',
  mixins: [base],
  props: {
    mergeStyle: {
      type: Object,
      default () {
        return {}
      },
    },
    color: {
      type: String,
      default: undefined,
    },
    opacity: {
      type: [String, Number],
      default: undefined,
    },
  },
  computed: {
    styles () {
      return Object.assign(
        {},
        {
          color: this.color,
          opacity: this.opacity,
        },
        this.mergeStyle
      )
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/HButton/CircleRipple.vue